export interface IApplication {
  id: number;
  code: string;
  description: string;
}


export interface ICreateApplicationRequest {
  code: string;
  description: string;
}

export interface IUpdateApplicationRequest extends ICreateApplicationRequest {
  id: number;
}
